module.exports = __webpack_public_path__ + "static/media/non-op.3952e931.png";